//Flickity Slider
import Flickity from 'flickity';
import 'flickity-imagesloaded/flickity-imagesloaded';

export function initHeroCarousel() {
    if (window.acf) {
        window.acf.addAction(
            'render_block_preview/type=hero-carousel',
            heroCarousel
        );
    }
}

export function heroCarousel() {

    if (document.querySelector('.hero-carousel')) {
        var infoTop = new Flickity('.hero-carousel', {
            autoPlay: 6000,
            pageDots: true,
            prevNextButtons: false,
            groupCells: true,
            cellAlign: 'left',
            imagesLoaded: true,
            wrapAround: true
        });
    }
}
